import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import React, { useEffect, useState } from "react";
import Loader from "react-loaders";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  CustomInput,
  Modal,
  ModalHeader,
  Row,
} from "reactstrap";
import { api } from "../../_services/api.service";
import exceptionHandler from "../../_helpers/exceptionHandler";
import { AppHelper } from "../../_helpers/appHelper";
import ImageUploadField from "../../Components/ImageUploadField";
import swal from "sweetalert";

const PhaseSettings = ({
  phaseItem,
  showModal,
  toggleModal,
  reloadList,
  onItemDeteled,
}) => {
  let [isLoading, setIsLoading] = useState(false);
  let [isServerProcessing, setIsServerProcessing] = useState(false);
  let [phase, setPhase] = useState(phaseItem);

  useEffect(() => {
    setPhase(phaseItem)
  }, [phaseItem, showModal]);

  const handleSubmit = async (e, errors, values) => {
    if (errors.length > 0)
      return;

    setIsServerProcessing(true);
    if (phase.phaseID === -1) { // create new phase
      await api.createPhase(phase)
      .then(created =>{
        if (created) toggleModal();
        else AppHelper.showErrorToast();
      })
      .catch(exceptionHandler);
    } else { // update existing phase
      await api.updatePhase(phase)
      .then(created =>{
        if (created) toggleModal();
        else AppHelper.showErrorToast();
      })
      .catch(exceptionHandler);
    }

    setIsServerProcessing(false);
    reloadList && reloadList();
  };

  const removePhase = () => {
    swal({
      text: "Removing this will also remove the Milestones and Fields associated to this phase. Are you sure you want to remove this item? ",
      icon: "warning",
      buttons: {
        ok: "Yes",
        cancel: "No",
      },
      dangerMode: true,
    }).then(async (val) => {
      if (val) {
        setIsServerProcessing(true);
        await api.deletePhase(phase.phaseID)
          .then(deleted => {
            if (deleted) {
              toggleModal();
              onItemDeteled && onItemDeteled();
            } else AppHelper.showErrorToast();
          })
          .catch(exceptionHandler);

        setIsServerProcessing(false);
      }
    });
  };

  const handleImageInputChange = (event) => {
    const fileUploaded = event.target.files[0];
    AppHelper.uploadImage(fileUploaded)
      .then(url => {
        setPhase({ ...phase, icon: url });
      });
  };

  return (
    <Modal
      size="lg"
      isOpen={showModal}
      toggle={toggleModal}
      backdrop="static"
    >
      <ModalHeader toggle={toggleModal}>{phaseItem.phaseText ? phaseItem.phaseText : "New"} phase</ModalHeader>
      {isLoading && <Loader style={{}} type="ball-pulse" active />}
      {!isLoading && (
        <Row style={{ marginTop: "30px" }}>
          <Col md="12">
            <Card className="main-card mb-3">
              <CardBody>
                <AvForm onSubmit={handleSubmit}>
                  <Row>
                    <Col md="12">
                      <AvField
                        name="phaseText"
                        label="Phase *"
                        value={phase.phaseText}
                        onChange={(e) =>
                          setPhase({
                            ...phase,
                            phaseText: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                        required
                      />

                      <div className="form-group">
                        <label>Order</label>
                        <Input
                          type="number"
                          value={phase.orderID}
                          onChange={(e) => {
                            let val = e.target.value;
                            if (
                              e.target.value != null &&
                              e.target.value.indexOf(".") !== -1
                            ) {
                              val = e.target.value.split(".")[0];
                            }
                            setPhase({ ...phase, orderID: val });
                          }
                          }
                        />
                      </div>

                      <div className="form-group">
                        <CustomInput
                          type="checkbox"
                          id="scoreAlternatives"
                          checked={phase.scoreAlternatives}
                          label="Score Alternatives"
                          onChange={(e) => setPhase({ ...phase, scoreAlternatives: e.target.checked })}
                        />
                      </div>

                      <ImageUploadField
                        label={"Icon"}
                        imageUri={phase.icon}
                        handleImageInputChange={handleImageInputChange}
                      />

                      <AvField
                        name="introText"
                        label="Intro Text"
                        value={phase.introText}
                        type="textarea"
                        style={{ height: "100px" }}
                        onChange={(e) =>
                          setPhase({
                            ...phase,
                            introText: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                      />

                      <AvField
                        name="unlockMessage"
                        label="Unlock Message"
                        value={phase.unlockMessage}
                        type="textarea"
                        style={{ height: "100px" }}
                        onChange={(e) =>
                          setPhase({
                            ...phase,
                            unlockMessage: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                      />

                      <AvField
                        name="lockReason"
                        label="Lock Reason"
                        value={phase.lockReason}
                        type="textarea"
                        style={{ height: "100px" }}
                        onChange={(e) =>
                          setPhase({
                            ...phase,
                            lockReason: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                      />

                      <div className="form-group">
                        <label>Milestone Screen Type</label>
                        <CustomInput
                          type="select"
                          id={"milestoneScreenTypeEditable"}
                          value={phase.milestoneScreenType}
                          className="form-control"
                          name={"milestoneScreenTypeEditable"}
                          onChange={(e) => {
                            setPhase({
                              ...phase,
                              milestoneScreenType: e.target.value,
                            })
                          }}
                        >
                          {["List", "Circle"].map((x) => {
                            return (
                              <option key={x} value={x}>
                                {x}
                              </option>
                            );
                          })}
                        </CustomInput>
                      </div>
                    </Col>

                  </Row>
                  <div className="pull-right">
                    {isServerProcessing && <Loader style={{}} type="ball-pulse" active />}
                    <Button
                      color="primary"
                      type="submit"
                      style={{ marginRight: ".25rem" }}
                      disabled={isServerProcessing}
                    >
                      Save
                    </Button>
                    {phase.phaseID !== -1 && (
                      <Button disabled={isServerProcessing} color="danger" onClick={() => removePhase()}>
                        Delete
                      </Button>)}
                    <Button
                      color="link"
                      className="pull-right"
                      onClick={() => toggleModal()}
                    >
                      Cancel
                    </Button>
                  </div>
                </AvForm>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </Modal>
  );
};

PhaseSettings.propTypes = {
  phaseItem: PropTypes.shape({
    phaseID: PropTypes.number,
    partnerScenarioID: PropTypes.number,
    phaseText: PropTypes.string,
    orderID: PropTypes.number,
    scoreAlternatives: PropTypes.bool,
    icon: PropTypes.string,
    introText: PropTypes.string,
    unlockMessage: PropTypes.string,
    milestoneScreenType: PropTypes.oneOf(['List', 'Circle']),
    lockReason: PropTypes.string,
  }),
  showModal: PropTypes.bool,
  toggleModal: PropTypes.func,
  reloadList: PropTypes.func,
  onItemDeteled: PropTypes.func,
};

PhaseSettings.defaultProps = {
  phaseItem: {
    phaseID: -1,
    partnerScenarioID: -1,
    phaseText: "",
    orderID: 0,
    scoreAlternatives: false,
    icon: "",
    introText: "",
    unlockMessage: "",
    milestoneScreenType: "List",
    lockReason: ""
  },
  showModal: false,
};

export default PhaseSettings;